import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class LegendItemListAPI extends ComponentAPI {
    /**
     * Gets the items of the legend list.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Sets the items of the legend list.
     *
     * @param data - The items of the legend list
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Gets the justify content property.
     */
    getJustifyContent() {
        return this.state.justifyContent;
    }
    /**
     * Sets justify content property of the list.
     *
     * @param justifyContent - Justify content value.
     */
    setJustifyContent(justifyContent) {
        this.setState({ justifyContent });
    }
    /**
     * Checks if the legend label is hidden.
     */
    isHideLegendLabel() {
        return Boolean(this.state.hideLegendLabel);
    }
    /**
     * Sets the hide legend label property.
     *
     * @param hideLegendLabel - If it should hide the legend label.
     */
    setHideLegendLabel(hideLegendLabel) {
        this.setState({ hideLegendLabel });
    }
    /**
     * Gets the size property.
     */
    getSize() {
        return this.state.size;
    }
    /**
     * Sets size property.
     *
     * @param size - Size value.
     */
    setSize(size) {
        this.setState({ size });
    }
    /**
     * Checks if the list is vertical.
     */
    isVertical() {
        return Boolean(this.state.vertical);
    }
    /**
     * Sets vertical property.
     *
     * @param vertical - vertical value.
     */
    setVertical(vertical) {
        this.setState({ vertical });
    }
}
export { LegendItemListAPI, };
//# sourceMappingURL=legend-item-list-api.js.map